import {
  ActivatedRouteSnapshot,
  CanDeactivateFn,
  RouterStateSnapshot
} from '@angular/router';
import { Observable } from 'rxjs';

export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

export const canDeactivateGuard: CanDeactivateFn<any> = (
  component: any,
  currentRoute: ActivatedRouteSnapshot,
  currentState: RouterStateSnapshot,
  nextState?: RouterStateSnapshot
): Observable<boolean> | Promise<boolean> | boolean => {
  if (component.unsavedChanges) {
    const nextUrl = nextState?.url || '';
    const value = component.canDeactivate ? component.canDeactivate(nextUrl) : true;
    if (value) {
      component.onceDestroyed = true;
    }

    return value;
  }
  return true;
};
